import { palette } from '../../styles/tokens';

export type JobTab = 'active' | 'completed' | 'templates';

export const JOB_TABS: { key: JobTab; label: string }[] = [
  { key: 'active', label: 'Active Jobs' },
  { key: 'completed', label: 'Completed' },
  { key: 'templates', label: 'Templates' },
];

export const JOB_STATUSES: Record<string, { label: string; bg: string; fg: string }> = {
  new: { label: 'New', bg: palette.g100, fg: palette.g500 },
  assigned: { label: 'Assigned', bg: palette.blueWash, fg: palette.blue },
  en_route: { label: 'En Route', bg: '#FFF7ED', fg: '#CA5010' },
  on_site: { label: 'On Site', bg: palette.greenWash, fg: palette.green },
  completed: { label: 'Completed', bg: palette.greenWash, fg: palette.green },
  cancelled: { label: 'Cancelled', bg: palette.redWash, fg: palette.red },
};

export const JOB_PRIORITIES: Record<string, { label: string; bg: string; fg: string }> = {
  low: { label: 'Low', bg: palette.greenWash, fg: palette.green },
  medium: { label: 'Medium', bg: palette.amberWash, fg: palette.amber },
  high: { label: 'High', bg: palette.redWash, fg: palette.red },
};

export const ACTIVE_STATUSES = ['new', 'assigned', 'en_route', 'on_site'];
export const STATUS_FLOW = ['new', 'assigned', 'en_route', 'on_site', 'completed'];

export const TH: React.CSSProperties = {
  fontSize: 11, fontWeight: 600, color: palette.g400, textTransform: 'uppercase',
  letterSpacing: '0.06em', padding: '10px 12px', textAlign: 'left',
  borderBottom: `1px solid ${palette.g150}`, whiteSpace: 'nowrap',
};
export const TD: React.CSSProperties = {
  fontSize: 13, color: palette.g700, padding: '10px 12px',
  borderBottom: `1px solid ${palette.g100}`, whiteSpace: 'nowrap',
};
export const LABEL: React.CSSProperties = {
  fontSize: 13, fontWeight: 500, color: palette.g500, marginBottom: 4, display: 'block',
};
export const INPUT: React.CSSProperties = {
  width: '100%', padding: '9px 12px', borderRadius: 8,
  border: `1px solid ${palette.g200}`, fontSize: 13.5, color: palette.g800,
  fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' as const,
};
